// extracted by mini-css-extract-plugin
module.exports = {"read-more-link":"styles-m__read-more-link__1VSHO","arrow-right":"styles-m__arrow-right__2jQo5","text":"styles-m__text__28qq9","special":"styles-m__special__1NZUx"};